import React from "react";
import DragIcon from "_c/icon/Drag";

const TodoDragHandle = (props) => {
  return (
    <button
      data-todo-ignore-click
      css={`
        touch-action: none;
        cursor: move;
        line-height: 0;
        margin-inline-end: 4px;
        padding: 4px;
        user-select: none;
        padding-left: 0;
      `}
      ref={props.dragHandleRef}
      {...props.dragHandleListeners}
    >
      <DragIcon width="18" color="#B8C1CC" />
    </button>
  );
};

export default TodoDragHandle;
